import { gql, useMutation } from '@apollo/client';

import { ONBOARDING_FAMILY_FRAGMENT } from '../queries/useOnboardingState';

import type {
  CreateDependentAndRelationshipMutation,
  CreateDependentAndRelationshipMutationVariables,
} from './__generated__/useCreateDependentAndRelationship.gql';

const CREATE_DEPENDENT_AND_RELATIONSHIP = gql`
  mutation CreateDependentAndRelationship($input: CreateDependantAndRelationshipInput!) {
    createDependantAndRelationship(input: $input) {
      ...OnboardingFamilyFragment
    }
  }
  ${ONBOARDING_FAMILY_FRAGMENT}
`;

/**
 * Creates a `Dependant` row and the caregiver edge from the acting user.
 * Returns the parent `Family` with its updated caregiver-relationship list
 * so Apollo's normalized cache updates `GetOnboardingState` and
 * `GetDependents` automatically — no `refetchQueries` or manual
 * refetch needed at the call site.
 */
export const useCreateDependentAndRelationship = () => {
  return useMutation<CreateDependentAndRelationshipMutation, CreateDependentAndRelationshipMutationVariables>(
    CREATE_DEPENDENT_AND_RELATIONSHIP
  );
};
